import React, { createContext, useState, useContext, useRef } from 'react';

const VideoContext = createContext();

export const useVideo = () => useContext(VideoContext);

export const VideoProvider = ({ children }) => {
    const [videoState, setVideoState] = useState({
        url: null,
        currentTime: 0,
        isPlaying: false,
        isFloating: false,
        isMuted: false,
        volume: 1
    });

    const floatVideo = (url, currentTime, isPlaying = true) => {
        setVideoState(prev => ({
            ...prev,
            url,
            currentTime,
            isPlaying,
            isFloating: true
        }));
    };

    const closeFloatingVideo = () => {
        setVideoState(prev => ({
            ...prev,
            isFloating: false,
            isPlaying: false
        }));
    };

    const dockVideo = () => {
        // Return to embedded mode
        // We just turn off floating, but keep state so embedded player can pick it up?
        // Actually, for simplicity, 'dock' just means hiding the floating player.
        // The embedded player needs to know to sync.
        setVideoState(prev => ({
            ...prev,
            isFloating: false
        }));
    };

    const updateVideoState = (newState) => {
        setVideoState(prev => ({ ...prev, ...newState }));
    };

    return (
        <VideoContext.Provider value={{ videoState, floatVideo, closeFloatingVideo, dockVideo, updateVideoState }}>
            {children}
        </VideoContext.Provider>
    );
};
